import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponse } from '../models/base.response';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { CategoryExperts } from '../models/categoriesexperts.model';
import { VideoCategory } from '../models/video.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryExpertsService {
  constructor(private http: HttpClient) { }

  findAll(): Observable<VideoCategory[]> {
    return this.http.get<VideoCategory[]>(`${environment.apiUrl}/configurations/expert-categories`);
  }
  findById(id: string): Observable<VideoCategory> {
    return this.http.get<VideoCategory>(`${environment.apiUrl}/configurations/expert-categories/${id}`);
  }
  delete(id: string): Observable<VideoCategory> {
    return this.http.delete<VideoCategory>(`${environment.apiUrl}/configurations/expert-categories/${id}`);
  }
  create(category: CategoryExperts): Observable<VideoCategory> {
    return this.http.post<VideoCategory>(`${environment.apiUrl}/configurations/expert-categories`, category);
  }
  update(id: string,category: CategoryExperts): Observable<VideoCategory> {
    return this.http.put<VideoCategory>(`${environment.apiUrl}/configurations/expert-categories/${id}`, category);
  }

}
